import { Box, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import Popover from 'modules/core/components/Popover'
import i18n from 'modules/core/lib/i18n'

import FilterSelect from 'modules/surveys/components/Table/FilterSelect'
import type { SurveysConfigFilters } from 'modules/surveys/components/Table/forms'
import Survey from 'modules/surveys/store/models/v2/Survey'

interface OptionsProps {
  filtersForm: SurveysConfigFilters
  onFilterStatus: (status: string) => void
}

const Options = observer(({ filtersForm, onFilterStatus }: OptionsProps) => {
  const statusOptions = [
    {
      value: Survey.Status.draft,
      label: i18n.t('surveys.index.table.filters.draft'),
    },
    {
      value: Survey.Status.active,
      label: i18n.t('surveys.index.table.filters.active'),
    },
    {
      value: Survey.Status.finished,
      label: i18n.t('surveys.index.table.filters.closed'),
    },
  ]

  const statusField = filtersForm.get('status')

  return (
    <Box padding="s24" gap="s16">
      <Box gap="s8" alignItems="flexStart">
        <Text size="300" weight="medium">
          {i18n.t('surveys.index.table.filters.title')}
        </Text>
        <Text size="300" color="grey800">
          {i18n.t('surveys.index.table.filters.description')}
        </Text>
      </Box>
      <Select
        label={i18n.t('surveys.index.table.filters.status')}
        onChange={() => onFilterStatus(statusField.value)}
        field={statusField}
        options={statusOptions}
        none={i18n.t('filters.filter.none')}
      />
    </Box>
  )
})
interface Props {
  filtersForm: SurveysConfigFilters
  onFilterStatus: (status: string) => void
}

const Filters = ({ filtersForm, onFilterStatus }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Box height="full">
      <Popover open={open} toggle={toggle} attachment="top center" size="auto">
        <FilterSelect toggle={toggle} open={open} />
        <Options filtersForm={filtersForm} onFilterStatus={onFilterStatus} />
      </Popover>
    </Box>
  )
}

export default observer(Filters)
